import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import CardActions from '@mui/material/CardActions';
import CardMedia from '@mui/material/CardMedia';
import { Box, CardActionArea, Container, Paper } from '@mui/material';
import { useState, useEffect } from 'react';
import './home.css';
import { useGlobal } from '../../utils/GlobalContext';
import { session } from '../../data/session';

interface KeynoteData {
    KeyNoteDTO: {
      FirstName: string[];
      LastName: string[];
      PictureLink: string[];
      SocialMediaLinks: {
        SocialMediaLink: string[];
        SocialMediaIcon: string[];
      }[];
      SessionTitle: string[];
      SessionDescription: string[];
      VideoLink: string[];
      VideoThumbnail: string[];
    }[];
  }

export default function PreviousKeynoteComponent() {
    const { state } = useGlobal();
    //Filter for keynote sessions
    const [pastKeynotes, setPastKeynotes] = useState<session[]>();
    useEffect(()=>{
        if(state.Conference?.Keynotes.length!==0 && pastKeynotes?.length===undefined){
            const tempPastKeynotes: session[] = state.Conference?.Keynotes.filter(function (el) {
                return el.EventId!== state.Conference?.CurrentEventId;
            });
            setPastKeynotes(tempPastKeynotes);
        }
    });
    // const [keynoteData, setKeynoteData] = useState<KeynoteData>({
    //     KeyNoteDTO: [
    //       {
    //         FirstName: [''],
    //         LastName: [''],
    //         PictureLink: [''],
    //         SocialMediaLinks: [
    //           {
    //             SocialMediaLink: [''],
    //             SocialMediaIcon: [''],
    //           },
    //         ],
    //         SessionTitle: [''],
    //         SessionDescription: [''],
    //         VideoLink: [''],
    //         VideoThumbnail: [''],
    //       },
    //     ],
    //   });


    // useEffect(() => {
    //     fetch('http://localhost:7071/api/Keynote')
    //       .then(async (response) => {
    //         const data = await response.json();
    //         if (!response.ok) {
    //           const error = (data && data.message) || response.statusText;
    //           return Promise.reject(error);
    //         }
    //         console.log(data);
      
    //         const updatedKeynoteData: KeynoteData = {
    //           KeyNoteDTO: data.map((item: any) => ({
    //             FirstName: [item.FirstName],
    //             LastName: [item.LastName],
    //             PictureLink: [item.PictureLink],
    //             SocialMediaLinks: item.SocialMediaLinks.map((socialMediaItem: any) => ({
    //               SocialMediaLink: [socialMediaItem.SocialMediaLink || ''],
    //               SocialMediaIcon: [socialMediaItem.SocialMediaIcon || ''],
    //             })),
    //             SessionTitle: [item.SessionTitle],
    //             SessionDescription: [item.SessionDescription],
    //             VideoLink: [item.VideoLink],
    //             VideoThumbnail: [item.VideoThumbnail]
    //           })),
    //         };
      
    //         setKeynoteData(updatedKeynoteData);
    //       })
    //       .catch((error) => {
    //         alert('Error');
    //         console.error('There was an error', error);
    //       });
    //   }, []);

    return (
        <>
             {pastKeynotes?.length===0? (
            <div>
            </div>
          ) : (
            <>
        
            <center>
                <h1 className='blueText'>Previous Year Keynote Videos</h1>
                <h2 className='smallText'>Get inspired by previous keynotes from previous {state.Conference.Name}.</h2>
            </center>
               
                <br/>
        
            {
           
            <Grid sx={{ flexGrow: 1 }} container spacing={2}>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" spacing={2}>
                        {pastKeynotes?.map((keynote) => (
                        <Grid key={keynote.Id} item>
                            <Card
                                sx={{
                                    height: 240,
                                    width: 500,
                                    backgroundColor: (theme) =>
                                    theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
                                }
                            }
                            >
                                <CardActionArea href={`${keynote.VideoLink}`}>
                                    <div className="PrevKeynoteContainer">
                                        <div className="PrevKeynoteContainer-small-images">
                                            {keynote.SessionSpeakers.map((keynoter)=>(
                                                    <>
                                                    <img className='KeynoteImage' src={keynoter.PictureLink===null?
                                                        "https://internationalwomensday.s3-us-west-2.amazonaws.com/images/IWD-WomenSpeakers.jpg"
                                                        :keynoter.PictureLink} title={keynoter.SpeakerName}/>
                                                    </>
                                                )
                                            )}
                                        </div>
                                        <div className="PrevKeynoteContainer-big-image">
                                            <img src={keynote.VideoThumbnail} title={keynote.Title}/>
                                        </div>
                                    </div>
                                </CardActionArea>
                            </Card>
                        </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
            }
        </>
        )}
        </>
    )
}